import React from 'react';
import { Container, H5 } from '@ui';
import styled from 'styled-components';
import { selectDarkTheme } from '@utils/themes';
import { PersonProfile, PersonProfileGrid } from '@ui/PersonProfile';

const Wrapper = styled.div`
  max-width: 840px;

  padding: 24px 60px 80px 60px;

  * {
    color: ${({ theme }) => selectDarkTheme(theme).text};
  }
`;

export const Advisors = () => {
  return (
    <Wrapper>
      <Container bottom={60}>
        <H5>ADVISORS</H5>
      </Container>

      <PersonProfileGrid>
        <PersonProfile
          name={'Suzanne Cain'}
          imgSrc={'/images/profiles/suzanne.png'}
          linkedInUrl={'https://www.linkedin.com/in/suzanne-cain-2b789076/'}
        >
          <ul>
            <li>Previously Global Head of Distribution, Janus Henderson</li>
            <li>Prior institutional sales leadership roles at BlackRock, Deutsche Bank, Morgan Stanley</li>
          </ul>
        </PersonProfile>
        <PersonProfile
          name={'Doug Haynes'}
          imgSrc={'/images/profiles/doug.png'}
          linkedInUrl={'https://www.linkedin.com/in/douglas-d-haynes/'}
        >
          <ul>
            <li>Previously President of Point72</li>
            <li>Previously Sr. Partner, McKinsey & Co</li>
          </ul>
        </PersonProfile>
      </PersonProfileGrid>
    </Wrapper>
  );
};
